import { Modal, Form, Row, Col } from 'react-bootstrap'
import { Formik } from 'formik'
import api from '../../../config/AxiosInstance'
import * as Common from '../../../utils/Common'
import CustomCloseButton from '../../Button/CustomCloseButton'
import CustomButton from '../../Button/CustomButton'
import { deliveryConfirmationUpdateItem } from '../../../utils/validationSchema'
import TextField from '../../Input/TextInput'

function ModalUpdateQtyDc({ selectedItem, onHide, refreshdata, ...props }) {
  const handleSubmit = async (values) => {
    try {
      const res = await api.put(
        `/outbound/dcdrafts/update-difference/${selectedItem?.item_id}`,
        values
      )

      if (res.data.success) {
        Common.showPopUpSuccessMessage(res?.data?.message)
        onHide()
        if (typeof refreshdata === 'function') {
          await refreshdata()
        }
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const getInitialQty = () => {
    if (!selectedItem) return 0
    if (
      selectedItem.confirmed_qty !== undefined &&
      selectedItem.confirmed_qty !== null &&
      selectedItem.confirmed_qty !== ''
    ) {
      const parsed = parseFloat(
        String(selectedItem.confirmed_qty).replace(/[^0-9.-]+/g, '')
      )
      if (!isNaN(parsed)) return parsed
    }
    if (
      selectedItem.total_qty !== undefined &&
      selectedItem.total_qty !== null
    ) {
      const parsedTotal = parseFloat(
        String(selectedItem.total_qty).replace(/[^0-9.-]+/g, '')
      )
      if (!isNaN(parsedTotal)) return parsedTotal
    }
    return 0
  }

  return (
    <Modal {...props} centered onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Input Confirmed Pack Qty</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          enableReinitialize={true}
          initialValues={{
            qty: getInitialQty()
          }}
          validationSchema={deliveryConfirmationUpdateItem}
          validateOnChange={true}
          validateOnBlur={true}
          onSubmit={handleSubmit}
        >
          {({
            handleBlur,
            handleSubmit,
            handleChange,
            values,
            errors,
            touched,
            isValid,
            isSubmitting
          }) => (
            <Form className="d-grid gap-2" onSubmit={handleSubmit}>
              <Row>
                <Col md={12} className="mb-3">
                  <h5>{selectedItem?.item}</h5>
                </Col>
                <Col md={12}>
                  <TextField
                    label="pack qty"
                    name="qty"
                    value={values.qty}
                    placeholder="0"
                    type="number"
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    touched={touched}
                    errors={errors}
                    required={true}
                  />
                </Col>
              </Row>
              <Modal.Footer className="mt-3">
                <CustomCloseButton onClick={onHide} />
                <CustomButton
                  onClick={handleSubmit}
                  variant="warning"
                  disabled={!isValid || isSubmitting}
                  text="Save"
                />
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default ModalUpdateQtyDc
